(() => {
  const elementName = 'ug-jp-spokesperson-special';
  if (customElements.get(elementName)) return;

  let activeInstance = null;

  class SpokespersonSpecial extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('[data-special-dialog]');
      this.player = this.querySelector('[data-special-player]');
      this.dialogTitle = this.querySelector('[data-special-dialog-title]');
      if (!this.dialog || !this.player) return;

      this.controller = new AbortController();
      this.defaultTitle = this.dialogTitle?.textContent || '';
      this.backdropPointer = false;
      const signal = this.controller.signal;

      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : event.target.parentElement;
        if (!target || target.closest(elementName) !== this) return;
        const opener = target.closest('[data-special-open]');
        if (opener) {
          event.preventDefault();
          this.open(opener);
        } else if (target.closest('[data-special-close]')) {
          event.preventDefault();
          this.close();
        }
      }, { signal });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.cleanup();
      }, { signal });
      this.dialog.addEventListener('pointerdown', (event) => {
        this.backdropPointer = event.isPrimary !== false && event.button === 0 && this.isBackdrop(event);
      }, { signal });
      this.dialog.addEventListener('pointercancel', () => {
        this.backdropPointer = false;
      }, { signal });
      this.dialog.addEventListener('click', (event) => {
        if (this.backdropPointer && this.isBackdrop(event)) this.close();
        this.backdropPointer = false;
      }, { signal });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target instanceof Element && event.target.contains(this)) this.close(false);
      }, { signal });
    }

    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
      this.controller = null;
    }

    isBackdrop(event) {
      if (event.target !== this.dialog) return false;
      const bounds = this.dialog.getBoundingClientRect();
      return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    }

    open(opener) {
      const template = document.getElementById(opener.dataset.templateId);
      if (!(template instanceof HTMLTemplateElement) || template.closest(elementName) !== this) return;
      const content = template.content.cloneNode(true);
      if (!content.querySelector('video, iframe')) return;
      if (this.dialog.open && this.returnFocus === opener) return;

      activeInstance?.close(false);
      window.pauseAllMedia?.();
      this.returnFocus = opener;
      const media = content.querySelector('video, iframe');
      if (media.matches('.js-youtube')) {
        const source = new URL(media.src);
        source.searchParams.set('origin', window.location.origin);
        media.src = source.href;
      }
      const trackingContext = window.UGJPTracking?.context(opener) || {
        module_id: 'special', section_id: this.dataset.jpSectionId,
        button_id: 'video_open', video_id: opener.dataset.jpVideoId, destination: 'modal'
      };
      this.cleanupTracking = window.UGJPVideoTracking?.attach(media, trackingContext);
      this.player.replaceChildren(content);
      if (this.dialogTitle) this.dialogTitle.textContent = opener.dataset.videoTitle || this.defaultTitle;

      this.lockedBody = document.body;
      this.previousOverflow = this.lockedBody.style.getPropertyValue('overflow');
      this.previousOverflowPriority = this.lockedBody.style.getPropertyPriority('overflow');
      this.lockedBody.style.setProperty('overflow', 'hidden');
      activeInstance = this;

      try {
        this.dialog.showModal();
      } catch {
        this.cleanup();
        return;
      }

      this.dialog.querySelector('[data-special-close]')?.focus({ preventScroll: true });
      this.player.querySelector('video')?.play()?.catch(() => {});
    }

    close(restoreFocus = true) {
      if (this.dialog?.open) this.dialog.close();
      this.cleanup(restoreFocus);
    }

    cleanup(restoreFocus = true) {
      this.cleanupTracking?.();
      this.cleanupTracking = null;
      this.player?.querySelectorAll('video').forEach((video) => {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        video.load();
      });
      this.player?.replaceChildren();
      this.backdropPointer = false;

      if (this.lockedBody) {
        if (this.previousOverflow) {
          this.lockedBody.style.setProperty('overflow', this.previousOverflow, this.previousOverflowPriority);
        } else {
          this.lockedBody.style.removeProperty('overflow');
        }
        this.lockedBody = null;
      }

      if (activeInstance === this) activeInstance = null;
      const opener = this.returnFocus;
      this.returnFocus = null;
      if (restoreFocus && opener?.isConnected) opener.focus({ preventScroll: true });
    }
  }

  customElements.define(elementName, SpokespersonSpecial);
})();
